import { Tag } from "../Tag";

import { useState, useEffect, useRef, useContext } from "preact/hooks";
import { locationCategories } from "../static-data";
import {
  handleDropdownClose,
  handleDropdownOpen,
  isMobileScreen,
  capitalizeFirstLetter,
} from "../../helpers";

import style from "./CityFilter.css";

import { Context } from "../Context";

const CityFilter = ({ cityFilter, onSetCityFilter, onBreakingChange }) => {
  const [context, setContext] = useContext(Context);
  const node = useRef();
  const customInput = useRef();
  const [customLocationInput, setCustomLocationInput] = useState("");

  // useEffect(() => {
  //   window.addEventListener("popstate", handlePop);
  //   return () => {
  //     document.removeEventListener("popstate", handlePop);
  //   };
  // }, []);

  // const handlePop = (event) => {
  //   if (window.location.search.indexOf("cityOpen") >= 0) {
  //     setContext({ ...context, filterOpen: "cityOpen" });
  //   } else {
  //     if (window.location.search.indexOf("cityOpen") < 0) {
  //       setContext({ ...context, filterOpen: "" });
  //     }
  //   }
  // };

  const handleCityFilterOpen = () => {
    handleDropdownOpen("cityOpen");
    setContext({ ...context, filterOpen: "cityOpen" });
  };

  const handleCityFilterClose = () => {
    handleDropdownClose("cityOpen");
    setContext({ ...context, filterOpen: "" });
  };

  const conditionalMobileHeader = () => {
    if (!isMobileScreen()) return null;
    if (isMobileScreen()) {
      return (
        <div class={style.mobileCityHeader}>
          <div class={style.closeIcon} onClick={handleCityFilterClose}></div>
          <h4>Stadt</h4>
          <div class={style.hidden}>x</div>
        </div>
      );
    }
  };

  const renderListItemStyle = (title) =>
    title === cityFilter ? style.selectedCityListItem : style.cityListItem;

  const handleCitySelected = (location) => {
    if (location.title === cityFilter) {
      onSetCityFilter(undefined);
    } else {
      onBreakingChange(true);
      onSetCityFilter({
        name: location.title,
        lat: location.lat,
        lng: location.lng,
      });
    }
  };

  const handleOnLocationFocus = (e) => {
    if (!window.mapsScriptLoaded) {
      loadScript(
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyB1oyZUjALeUEe2Y0HdMXPZ9k4UFO925MA&libraries=places,geometry&region=DE",
        function () {
          window.mapsScriptLoaded = true;
          bindInputToMaps(e.target);
        },
      );
    } else {
      bindInputToMaps(e.target);
    }
  };

  function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      // only required for IE <9
      script.onreadystatechange = function () {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      //Others
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  const bindInputToMaps = (locationInput) => {
    var options = {
      types: ["(cities)"],
      componentRestrictions: { country: ["de", "at", "ch"] },
    };

    var autocomplete = new google.maps.places.Autocomplete(
      locationInput,
      options,
    );

    autocomplete.addListener("place_changed", function () {
      let lat;
      let lng;
      var result = this.getPlace();

      if (!result.geometry) return;

      if (typeof result.geometry.location.lat === "number") {
        lat = result.geometry.location.lat;
      } else {
        lat = result.geometry.location.lat();
      }

      if (typeof result.geometry.location.lng === "number") {
        lng = result.geometry.location.lng;
      } else {
        lng = result.geometry.location.lng();
      }

      const city = locationCategories.find((loc) => loc.title === result.name);
      if (city) {
        // this city already exists in the list
        handleCitySelected(city);
      } else {
        onSetCityFilter({ name: result.name, lat, lng });
        setCustomLocationInput(result.name);
      }

      handleCityFilterClose();

      Object.entries(result.address_components).map(function (component) {
        var key = component[1].types[0];
        if (key === "route") {
          var placeStreet = component[1].long_name;
          var placeNumber = "";
          Object.entries(result.address_components).map(function (bcomponent) {
            var bkey = bcomponent[1].types[0];
            if (bkey === "street_number") {
              placeNumber = bcomponent[1].long_name;
            }
          });
          street = placeStreet + placeNumber;
        }
      });
    });
  };

  const handleClearCustomLocation = () => {
    if (customLocationInput.length !== 0) {
      setCustomLocationInput("");
      onSetCityFilter("");
    }
  };

  const conditionalRenderClearButton = () => {
    if (customLocationInput.length !== 0) {
      return (
        <div class={style.closeIconWrapper} onClick={handleClearCustomLocation}>
          <div class={style.closeIcon}></div>
        </div>
      );
    }
  };
  const conditionalRenderCityDropdown = () => {
    if (context.filterOpen === "cityOpen") {
      return (
        <div
          class={style.cityFilter}
          onClick={(e) => {
            if (!isMobileScreen()) {
              //check if it is the customInput clicked?
              if (
                customInput &&
                customInput.current &&
                customInput.current.contains(e.target)
              ) {
                //on desktop?

                if (!window.mapsScriptLoaded) {
                  loadScript(
                    "https://maps.googleapis.com/maps/api/js?key=AIzaSyB1oyZUjALeUEe2Y0HdMXPZ9k4UFO925MA&libraries=places,geometry&region=DE",
                    function () {
                      window.mapsScriptLoaded = true;
                      bindInputToMaps(customInput.current);
                    },
                  );
                } else {
                  bindInputToMaps(customInput.current);
                }
              } else {
                handleCityFilterClose();
              }
            }
          }}
        >
          <div
            class={style.cityFilterContainer}
            style={{
              left: node.current.base.getBoundingClientRect().left + "px",
              top: node.current.base.getBoundingClientRect().top + "px",
            }}
          >
            {conditionalMobileHeader()}
            <div class={style.cityListContainer}>
              <div class={style.customInput}>
                <input
                  ref={customInput}
                  class={style.locationSearch}
                  onFocus={handleOnLocationFocus}
                  placeholder="Bitte Stadt eingeben"
                  value={customLocationInput}
                  onInput={(e) => setCustomLocationInput(e.target.value)}
                />

                {conditionalRenderClearButton()}
              </div>
              <ul class={style.cityUl}>
                {locationCategories.map((location) => (
                  <li
                    key={location.key}
                    class={renderListItemStyle(location.title)}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleCitySelected(location);
                      handleCityFilterClose();
                    }}
                  >
                    {location.title}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Fragment>
      <Tag
        ref={node}
        id="mapCityFilter"
        text={cityFilter ? capitalizeFirstLetter(cityFilter) : "Stadt"}
        selected={cityFilter && cityFilter.length !== 0}
        onClick={handleCityFilterOpen}
        hasDropdown={true}
        shouldTruncate={true}
      />
      {conditionalRenderCityDropdown()}
    </Fragment>
  );
};

export { CityFilter };
